import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../../profile/root';
import { UserAccountAdapter } from './user-account.adapter';

@Injectable()
export class UserAccountConnector {
  constructor(protected adapter: UserAccountAdapter) {}

  get(): Observable<User> {
    return this.adapter.load();
  }
}
